import React from "react";
import { Link } from "react-router-dom";
import { footerData } from "../../data/data3";

export default function Footer1() {
    return (
        <div className="mt-12 pb-8 border-b border-gray-200">
            {/* Section title */}
            <Link to="/iot-use-cases">
                <h2 className="font-poppins smd:text-[13px] text-[15px] 2xl:text-3xl text-red-600 font-bold uppercase tracking-widest mb-5 hover:underline inline-block">
                    IOT USE CASES
                </h2>
            </Link>

            {/* 5-column grid of categories */}
            <div className="grid smd:grid-cols-2 grid-cols-5 gap-6">
                {footerData.map((item) => (
                    <div key={item.id}>
                        {/* Category heading */}
                        <Link to={item.link}>
                            <h3 className="font-poppins smd:text-[11px] text-[13px] 2xl:text-2xl font-bold text-gray-800 uppercase mb-2 hover:text-red-600 transition-colors">
                                {item.heading}
                            </h3>
                        </Link>

                        {/* Sub-items */}
                        <ul className="space-y-1">
                            {item.content.map((contentItem, i) => (
                                <li key={i}>
                                    <Link
                                        to={contentItem.link}
                                        className="font-roboto smd:text-[11px] text-[13px] 2xl:text-2xl text-gray-500 hover:text-red-600 hover:underline transition-colors leading-snug block"
                                    >
                                        {contentItem.text}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
}
